import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button, Alert } from "react-bootstrap";
import { AuthError } from "../../services/UserAuthService";

interface ErrorModalProps {
    show: boolean;
    onHide: () => void;
    error: AuthError | null;
    onReauth: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ show, onHide, error, onReauth }) => {
    const { t } = useTranslation("common");
    if (!error) return null;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {error.type === "auth" ? t("error.modal.authTitle") : t("error.modal.errorTitle")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant={error.type === "auth" ? "warning" : "danger"}>
                    <strong>{error.message}</strong>
                </Alert>

                {error.details && (
                    <details>
                        <summary>{t("error.modal.technicalDetails")}</summary>
                        <pre style={{ fontSize: "0.8em", marginTop: "10px" }}>{error.details}</pre>
                    </details>
                )}
            </Modal.Body>
            <Modal.Footer>
                {error.type === "auth" ? (
                    <>
                        <Button variant="secondary" onClick={onHide}>
                            {t("buttons.cancel")}
                        </Button>
                        <Button variant="primary" onClick={onReauth}>
                            {t("error.modal.buttons.loginAgain")}
                        </Button>
                    </>
                ) : (
                    <Button variant="primary" onClick={onHide}>
                        {t("buttons.close")}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ErrorModal;
